module.exports = __webpack_public_path__ + "img/Z61Q_10.2b18537a.jpg";